export const getPayPalCommission = (price: number): string => (price / 0.96 + 1.0 - price).toFixed(2);

export const getCardCommission = (price: number): string => (price / 0.98 + 0.5 - price).toFixed(2);

export const getStripeCommission = (price: number): string => (price * 0.030 + 0.25).toFixed(2);
